import Endpoints from '../endpoints';
import { axiosInstance } from '../instance';

const fail = (error, fallback) => {
  console.log(error);
  return { error: error?.response?.data?.error || fallback };
};

export const list = async () => {
  try {
    const res = await axiosInstance.get(Endpoints.FEEDS.LIST);
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось получить фиды');
  }
};

export const getOne = async (id) => {
  try {
    const res = await axiosInstance.get(Endpoints.FEEDS.ONE + id);
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось открыть фид');
  }
};

export const save = async (id, body) => {
  try {
    const res = await axiosInstance.put(Endpoints.FEEDS.ONE + id, body);
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось сохранить фид');
  }
};

export const addCity = async (body) => {
  try {
    const res = await axiosInstance.post(Endpoints.FEEDS.CITIES, body);
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось добавить город');
  }
};

export const create = async (body) => {
  try {
    const res = await axiosInstance.post(Endpoints.FEEDS.LIST, body);
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось создать фид');
  }
};

export const refreshPrices = async (id) => {
  try {
    const res = await axiosInstance.post(Endpoints.FEEDS.ONE + id + '/prices');
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось запустить обновление цен');
  }
};

export const checkIds = async (id, cities) => {
  try {
    const res = await axiosInstance.post(Endpoints.FEEDS.ONE + id + '/check-ids', { cities });
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось сверить фиды');
  }
};

export const regenerate = async (id) => {
  try {
    const res = await axiosInstance.post(Endpoints.FEEDS.ONE + id + '/regenerate');
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось запустить перегенерацию');
  }
};

export const uploadTemplate = async (id, file) => {
  try {
    const body = new FormData();
    body.append('file', file);
    const res = await axiosInstance.post(Endpoints.FEEDS.ONE + id + '/template', body);
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось загрузить шаблон');
  }
};

export const templateFile = async (id) => {
  try {
    const res = await axiosInstance.get(Endpoints.FEEDS.ONE + id + '/template-file', {
      responseType: 'blob',
    });
    return res.data;
  } catch (error) {
    return { error: 'Нет шаблона' };
  }
};

export const job = async (id) => {
  try {
    const res = await axiosInstance.get(Endpoints.FEEDS.ONE + 'jobs/' + id);
    return res.data;
  } catch (error) {
    return fail(error, 'Не удалось получить статус');
  }
};

const feeds = { list, getOne, save, addCity, create, refreshPrices, regenerate, checkIds, uploadTemplate, templateFile, job };
export default feeds;
